module.exports = __webpack_public_path__ + "img/ch09_15_赠鞋鞠躬.af2ee794.jpg";